var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22852,21.16016A6.11524,6.11524,0,0,1,3.9043,10.7207l8.15527-8.15429L13.333,3.83984l-8.15528,8.1543A4.31446,4.31446,0,1,0,11.2793,18.0957l8.06836-8.06738a2.574,2.574,0,0,0,0-3.63672,2.63292,2.63292,0,0,0-3.63672-.001L7.80957,14.28516a.88056.88056,0,0,0,.001,1.24414.89889.89889,0,0,0,1.24511,0l6.63282-6.63184,1.27343,1.27344L10.3291,16.80273a2.681,2.681,0,0,1-3.792-3.791l7.90137-7.89356a4.37212,4.37212,0,1,1,6.18261,6.1836l-8.06836,8.06738A6.07411,6.07411,0,0,1,8.22852,21.16016Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Kommentare"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "-11 26 -11 -5 140 -5",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.03d1f064.svg";
export { ForwardRef as ReactComponent };